(function () {
  const initializeBackToTop = function () {
    const control = document.querySelector('[data-back-to-top]');

    if (!control) {
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let updateFrame = null;

    const shouldReduceMotion = function () {
      return reducedMotion.matches
        || document.body.dataset.accessibility === 'true'
        || document.body.dataset.noImages === 'true';
    };

    const updateVisibility = function () {
      updateFrame = null;
      const visibilityThreshold = Math.max(320, window.innerHeight * 0.6);
      const distanceToPageEnd = document.documentElement.scrollHeight
        - window.scrollY
        - window.innerHeight;

      control.classList.toggle(
        'back-to-top--visible',
        window.scrollY > visibilityThreshold
      );
      control.classList.toggle(
        'back-to-top--near-page-end',
        distanceToPageEnd < 80
      );
    };

    const requestVisibilityUpdate = function () {
      if (updateFrame !== null) {
        return;
      }

      updateFrame = window.requestAnimationFrame(updateVisibility);
    };

    control.classList.add('back-to-top--enhanced');
    updateVisibility();

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });

    control.addEventListener('click', function (event) {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: shouldReduceMotion() ? 'auto' : 'smooth'
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBackToTop, { once: true });
  } else {
    initializeBackToTop();
  }
})();
